<!-- @format -->

<template>
	<div v-if="refresh">
		<div ref="searchForm" class="pc-tree-search-form">
			<el-input v-model="filterText" placeholder="组织名称【只搜索已加载数据】" clearable />
			<!-- <ibps-international-select
        v-model="filterText"
        :clearable="true"
        :placeholder="$t('platform.org.org.selector.name')+$t('platform.org.org.selector.searchTip')"
      /> -->
		</div>
		<div style="border: 1px solid #eee">
			<div v-if="toolbars" ref="toolbar" class="pc-tree-toolbar">
				<span style="line-height: 30px"> 请选择组织 </span>
				<el-dropdown size="default" class="platform-fr">
					<el-button icon="MoreFilled" size="small" style="border-radius: 5px" />
					<template #dropdown>
						<el-dropdown-menu class="ibps-table-dropdown-menu">
							<pc-toolbar :actions="toolbars" :type="'menu'" @action-event="handleTreeAction" />
						</el-dropdown-menu>
					</template>
				</el-dropdown>
			</div>
			<div :style="{ height: tableHeight + 'px' }">
				<el-scrollbar style="height: 100%" wrap-class="pc-tree-wrapper">
					<!-- 多选-->
					<el-tree
						v-if="partyTypeId !== 'script' && multiple && defaultExpandAll"
						ref="elTree"
						v-loading="loading"
						:data="treeData"
						:expand-on-click-node="false"
						:props="{ children: 'children', label: 'name', isLeaf: 'leaf' }"
						:show-checkbox="multiple"
						:check-strictly="true"
						:filter-node-method="filterNode"
						:default-expanded-keys="refreshData"
						:default-expand-all="true"
						:default-checked-keys="defaultCheckedKeys"
						:node-key="nodeKey"
						pid-key="parentId"
						highlight-current
						check-on-click-node
						@check-change="handleCheckChange"
					/>
					<el-tree
						v-if="partyTypeId !== 'script' && multiple && !defaultExpandAll"
						ref="elTree"
						v-loading="loading"
						:expand-on-click-node="false"
						:props="{ children: 'children', label: 'name', isLeaf: 'leaf' }"
						:show-checkbox="multiple"
						:check-strictly="true"
						:filter-node-method="filterNode"
						:default-expanded-keys="refreshData"
						:default-expand-all="defaultExpandAll"
						:default-checked-keys="defaultCheckedKeys"
						:load="loadTreeNode"
						lazy
						:node-key="nodeKey"
						pid-key="parentId"
						highlight-current
						check-on-click-node
						@check-change="handleCheckChange"
					/>
					<!-- 单选-->
					<el-tree
						v-else-if="partyTypeId !== 'script' && !multiple"
						ref="elTree"
						v-loading="loading"
						:data="treeData"
						:expand-on-click-node="false"
						:props="{ children: 'children', label: 'name', isLeaf: 'leaf' }"
						:filter-node-method="filterNode"
						:default-expanded-keys="refreshData"
						:default-expand-all="defaultExpandAll"
						:load="loadTreeNode"
						lazy
						:node-key="nodeKey"
						pid-key="parentId"
						highlight-current
						@node-click="onNodeClick"
					>
						<template #default="{ node, data }">
							<span class="custom-tree-node">
								<el-radio
									v-model="radio"
									:label="data[pkKey]"
									:disabled="data.disabled ? data.disabled : data.id === '0' ? true : null"
									@change="changeRadio(data)"
								>
									{{ node.label }}
								</el-radio>
							</span>
						</template>
					</el-tree>
					<!-- 动态脚本-->
					<!-- 多选 -->
					<!-- :render-content="handRenderContent" -->
					<el-tree
						v-if="partyTypeId === 'script' && multiple"
						ref="elTree"
						v-loading="loading"
						:data="treeData"
						:expand-on-click-node="false"
						:props="{ children: 'children', label: 'name' }"
						:show-checkbox="multiple"
						:filter-node-method="filterNode"
						:default-expanded-keys="refreshData"
						:default-expand-all="defaultExpandAll"
						:node-key="nodeKey"
						pid-key="parentId"
						highlight-current
						@check-change="handleCheckChange"
					/>
					<!-- 单选 -->
					<el-tree
						v-else-if="partyTypeId === 'script' && !multiple"
						ref="elTree"
						v-loading="loading"
						:data="treeData"
						:expand-on-click-node="false"
						:props="{ children: 'children', label: 'name' }"
						:filter-node-method="filterNode"
						:default-expanded-keys="refreshData"
						:default-expand-all="defaultExpandAll"
						:node-key="nodeKey"
						pid-key="parentId"
						highlight-current
						@node-click="onNodeClick"
					>
						<template #default="{ node, data }">
							<span class="custom-tree-node">
								<el-radio
									v-model="radio"
									:label="data[pkKey]"
									:disabled="data.disabled ? data.disabled : data.id === '0' ? true : null"
									@change="changeRadio(data)"
								>
									{{ node.label }}
								</el-radio>
							</span>
						</template>
					</el-tree>
				</el-scrollbar>
			</div>
		</div>
		<!-- <more-search
      ref="moreSearch"
      :title="title"
      :visible="dialogFormVisible"
      :party-type="partyType"
      @callback="search"
      @close="visible => dialogFormVisible = visible"
      @action-event="handleMoreSearchAction"
    /> -->
	</div>
</template>
<script>
	import TreeLazyEvens from './mixins/TreeLazyEvens';
	import { ActionUtils } from './action';
	import { TreeUtils } from './tree';
	import { PcToolbar } from '@/components/pc-toolbar/index';
	import { allNoticeAll, orgFindTreeDataByAll } from '@/api/position';
	import { $utils } from '@/utils/publicUtils';
	// import MoreSearch from './more-search'
	// import FormUtils from '@/business/platform/form/utils/formUtil'
	// import IbpsInternationalSelect from '@/views/platform/international/components/ibps-international-select'
	export default {
		components: {
			PcToolbar,
			// IbpsInternationalSelect
		},
		mixins: [TreeLazyEvens],
		props: {
			formData: [Object, Array], // 所有字段数据,(包含主主子表)
			value: [Object, Array],
			multiple: Boolean,
			height: {
				type: String,
				default: '400px',
			},
			partyTypeId: {
				// 类型节点ID
				type: [String, Number],
				default: '',
			},
			nodeKey: {
				type: String,
				default: 'id',
			},
			pkKey: {
				type: String,
				default: 'id',
			},
			refreshData: {
				type: Array,
				default: () => ['0'],
			},
			partyType: {
				type: String,
				default: 'org',
			},
			currentOrgId: {
				// 用户组ID
				type: [String, Number],
				default: '',
			},
			script: String,
			isUseScope: {
				// 是否启用范围
				type: Boolean,
				default: false,
			},
			hasSubset: {
				// 是否包含子集
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				defaultCheckedKeys: [],
				radio: '',
				loading: false,
				scriptExecuteTime: false, // 脚本函数是否只执行一次
				filterText: '',
				title: '更多查询',
				dialogFormVisible: false,
				defaultExpandAll: false,
				treeLazy: true,
				// 树配置
				treeData: [],
				rootTreeNode: [],
				toolbars: [
					{
						key: 'refresh',
						label: '刷新',
					},
					{
						key: 'expand',
						label: '展开',
					},
					{
						key: 'compress',
						label: '收缩',
					},
				],
				refresh: true,
			};
		},
		computed: {
			tableHeight() {
				const h = this.height.substr(0, this.height.length - 2);
				return parseInt(h) - 10;
			},
		},
		watch: {
			filterText(val) {
				this.$refs.elTree.filter(val);
			},
		},
		beforeUnmount() {
			this.treeData = null;
			this.rootTreeNode = null;
			this.toolbars = null;
		},
		mounted() {
			if (this.pkKey === 'id') {
				if ($utils.isNotEmpty(this.value)) {
					if (this.multiple) {
						const temp = [];
						this.defaultCheckedKeys = this.getDefaultCheckByValue(this.value, temp, this.nodeKey);
					} else {
						let temp = [];
						temp = this.getDefaultCheckByValue(this.value, temp, this.pkKey);
						if ($utils.isNotEmpty(temp)) {
							this.radio = temp[0] || '';
						}
					}
				} else {
					this.defaultCheckedKeys = [];
				}
			}

			if (this.partyTypeId === 'script') {
				this.loadTreeData();
			}
		},
		methods: {
			getDefaultCheckByValue(item, data, key) {
				if ($utils.isEmpty(item)) return data;
				if ($utils.isObject(item) && $utils.isNotEmpty(item[key])) {
					data.push(item[key]);
					return data;
				}
				item.forEach((el) => {
					if ($utils.isArray(el)) {
						this.getDefaultCheckByValue(el, data, key);
					} else if ($utils.isObject(el) && $utils.isNotEmpty(el[key])) {
						data.push(el[key]);
					}
				});
				return data;
			},
			// 脚本类型初始化
			loadTreeData() {
				if (this.scriptExecuteTime) return;
				this.loading = true;
				const dynamicValue = FormUtils.getCalDynamicValue(this.script, this.formData);
				dynamicValue.then((response) => {
					this.treeData = this.toTree(response);
					this.scriptExecuteTime = true;
				});
				this.loading = false;
			},
			// 懒加载分界线~~~~~~~~~~~~~~~~~~
			setCheckedNodes(data, selected) {
				if (this.multiple) {
					this.$refs['elTree'].setChecked(data, selected);
				} else {
					this.radio = '';
				}
			},
			cleanData(multiple) {
				if (multiple) {
					this.$refs['elTree'].setCheckedKeys([]);
				} else {
					this.radio = '';
				}
			},
			// 加载组织树
			loadTreeNode(node, resolve) {
				this.loading = true;
				const type = this.partyTypeId !== '' ? this.partyTypeId : '1';
				const hasSubset = this.hasSubset;
				if (type === '1') {
					this.findTreeDataByAll({ node }).then((data) => {
						this.loading = false;
						const arr = JSON.parse(JSON.stringify(data));
						resolve(this.toTree(arr));
					});
				} else if (type === '2') {
					this.loading = true;
					this.findTreeDataByTheOrg({ node, hasSubset }).then((data) => {
						this.loading = false;
						const arr = JSON.parse(JSON.stringify(data));
						if (this.isUseScope) {
							let treeData;
							if ($utils.isEmpty(node.data)) {
								treeData = arr;
								resolve(this.toTree(treeData));
							} else if (this.hasSubset && node.data.id !== '0') {
								// 根据是否包含子节点返回对应的数据
								treeData = this.filterTreeChildren(this.toTree(arr), 'node', node.data.id);
								resolve(this.toTree(treeData));
							} else {
								treeData = node.data.id === '0' ? this.filterTreeChildren(arr, 'root') : arr;
								resolve(this.toTree(treeData));
							}
						} else {
							resolve(this.toTree(arr));
						}
					});
				} else if (type === '3') {
					this.loading = true;

					this.findTreeDataByOrg({ node, hasSubset }).then((data) => {
						this.loading = false;
						const arr = JSON.parse(JSON.stringify(data));
						this.loading = false;
						if (this.isUseScope) {
							let treeData;
							if ($utils.isEmpty(node.data)) {
								treeData = arr;
								resolve(this.toTree(treeData));
							} else {
								treeData =
									node.data.id === '0'
										? this.filterTreeChildren(arr, 'root')
										: this.filterTreeChildren(this.toTree(arr), 'node', node.data.id);
								resolve(this.toTree(treeData));
							}
						} else {
							resolve(this.toTree(arr));
						}
					});
				}
			},
			// 根据渲染的数据范围类型，筛选目标节点
			filterTreeChildren(treeData, treeScope, nodeId) {
				let data = [];
				// 返回设置的范围节点
				if (treeScope === 'root') {
					const currentOrgIds = this.currentOrgId.split(',');
					treeData.forEach((f) => {
						if (currentOrgIds.includes(f.id)) {
							f.leaf = !this.hasSubset;
							data.push(f);
						}
					});
				}
				// 返回点击节点的子节点
				if (treeScope === 'node') {
					const filter = function (datas) {
						datas.find((item) => {
							if (item.children && item.children !== []) {
								if (item.id === nodeId) {
									data = item.children;
									return;
								}
								filter(item.children);
							}
						});
					};
					filter(treeData);
				}
				return data;
			},
			toTree(data) {
				if ($utils.isNotEmpty(data)) {
					for (let i = 0; i < data.length; i++) {
						if (data[i].id === '0' || data[i].id === 0) {
							data[i].disabled = true;
						}
					}
				}
				return TreeUtils.transformToTreeFormat(data, {
					idKey: 'id',
					pIdKey: 'parentId',
					childrenKey: 'children',
				});
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			/**
			 * 查询
			 */
			search() {
				ActionUtils.setPagination(this.pagination);
				this.loadListData();
			},
			/**
			 * 处理更多查询弹窗
			 */
			handleMoreSearch() {
				this.dialogFormVisible = true;
			},
			/**
			 * 重置查询
			 */
			resetSearch() {
				this.$refs['crud'] ? this.$refs['crud'].resetSearch() : null;
				ActionUtils.setFirstPagination(this.pagination);
				this.search();
			},
			/**
			 * 处理按钮事件
			 */
			handleAction(command) {
				switch (command) {
					case 'search': // 查询
						this.search();
						break;
					case 'resetSearch': // 重置查询
						this.resetSearch();
						break;
					default:
						break;
				}
			},
			handleTreeAction(action, position) {
				const command = action.key;
				if (position === 'toolbar' && command === 'refresh') {
					this.refresh = false;
					this.$nextTick(async () => {
						this.refresh = true;
						this.defaultExpandAll = false;
						this.$emit('selected', []);
					});
				}
				if (command === 'expand') {
					this.expandCompressTree(true);
				} else if (command === 'compress') {
					this.expandCompressTree(false);
				}
			},
			async expandCompressTree(expanded) {
				if (expanded) {
					const res = await orgFindTreeDataByAll({
						parameters: [
							{
								code: 'orgId',
								value: null,
							},
						],
					});
					const res1 = await allNoticeAll();
					this.treeData = [{ ...res[0], children: res1 }];
					this.defaultExpandAll = true;
				} else {
					for (let i = 0; i < this.$refs.elTree.store._getAllNodes().length; i++) {
						this.$refs.elTree.store._getAllNodes()[i].expanded = expanded;
					}
				}
			},
			handleCheckChange(data, checked) {
				if (data.id === 0 || data.id === '0') return;
				// let val = JSON.parse(JSON.stringify(this.value));
				let val = JSON.parse(JSON.stringify(this.$refs.elTree.getCheckedNodes()));
				if (checked) {
					const index = val.find((v) => {
						return v[this.pkKey] === data[this.pkKey];
					});
					if (!index) {
						val.push(data);
					}
				} else {
					val = val.filter((v) => {
						return v[this.pkKey] !== data[this.pkKey];
					});
				}
				if (!this.refresh) {
					return;
				}
				this.$emit('selected', val);
			},
			changeRadio(data) {
				if (data.id === 0 || data.id === '0') return;
				this.$emit('selected', data);
			},
			onNodeClick(data) {
				if (data.id === 0 || data.id === '0') return;
				this.radio = data[this.pkKey];
				this.$emit('selected', data);
			},
		},
	};
</script>

<style lang="scss" scoped>
	$border-color: #e5e6e7;

	.pc-tree-toolbar {
		background-color: #f3f4f8;
		height: 40px;
		padding: 5px 10px;
	}

	.pc-tree-search-form {
		background: #ffffff;
		margin-bottom: 5px;
	}

	.pc-tree-wrapper {
		background: #ffffff;

		.el-tree > .el-tree-node {
			display: inline-block;
		}
	}
</style>
